module.exports = __webpack_public_path__ + "cellphone-icon-524dafc5.png";